// extracted by mini-css-extract-plugin
module.exports = {"root":"Spinner_root__3qrPN","spinner":"Spinner_spinner__1Nh-g","load8":"Spinner_load8__vTduc"};